import React from "react";
import { useTheme } from "@mui/material/styles";
import Button from "../../../components/buttons/Button";
import { useNavigate, useParams } from "react-router-dom";
import { GetMaterial } from "../../../hooks/useServiceData";

export const MaterialOverviewView = () => {
  const theme = useTheme();

  const materialParam = useParams();
  const materialId = materialParam.id;

  const navigate = useNavigate();

  const { data } = GetMaterial(materialId);

  const clickEdit = (id) => {
    navigate(`/registry/material/edit/${id}`);
  };

  return (
    <>
      <div className="container" style={{ width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2>{data?.data.name}</h2>
          <div>
            <Button onClick={() => clickEdit(materialId)}>Redigera</Button>
          </div>
        </div>
        <table className="vertical-table">
          <tbody>
            <tr>
              <th>ID</th>
              <td>{data?.data.owner_id}</td>
            </tr>
            <tr>
              <th>Namn</th>
              <td>{data?.data.name}</td>
            </tr>
            <tr>
              <th>Kostnad</th>
              <td>{data?.data.cost}</td>
            </tr>
            <tr>
              <th>Kontoplan</th>
              <td>
                {data?.data.account.number} {data?.data.account.name}
              </td>
            </tr>
            <tr>
              <th>Aktiv</th>
              <td>
                <span
                  className="small-container"
                  style={{
                    background:
                      data?.data.isActive === 1
                        ? theme.palette.success.light
                        : theme.palette.error.light,
                    color:
                      data?.data.isActive === 1
                        ? theme.palette.success.main
                        : theme.palette.error.main,
                  }}
                >
                  {data?.data.isActive === 1 ? "Aktiv" : "Inaktiv"}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
